import { render, staticRenderFns } from "./Partenariats.vue?vue&type=template&id=38021176&"
import script from "./Partenariats.vue?vue&type=script&lang=js&"
export * from "./Partenariats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports